import {
  REQUEST_OTP_VERIFICATION,
  RESET_MFA_STATE,
  SEND_OTP,
  SEND_OTP_SUCCESS,
  VERIFY_OTP,
  VERIFY_OTP_SUCCESS
} from "../reducers/mfaReducer";
import Notify from "./notifyActions";

export const SEND_OTP_SUCCESSFUL_TOAST = 'success_sending_otp'
export const SEND_OTP_FAILURE_TOAST = 'error_sending_otp'

export const VERIFY_OTP_SUCCESSFUL_TOAST = 'success_verifying_otp'
export const VERIFY_OTP_FAILURE_TOAST = 'error_verifying_otp'

export const sendOtp = (data) => {
  return (dispatch, getState) => {

    const state = getState();
    const {mfaEmailAddress, mfaContactNumber} = state.mfaReducer;
    const {selectedLanguage} = state.languageReducer;

    return new Promise((resolve, reject) => {
      dispatch({
        type: SEND_OTP,
        payload: {
          request: {
            mode: 'no-cors',
            url: 'otp/send',
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            data: {
              ...data,
              emailAddress: mfaEmailAddress,
              contactNumber: mfaContactNumber,
              language: selectedLanguage
            }
          }

        }
      }).then(response => {
        if (response.type === SEND_OTP_SUCCESS) {
          // dispatch(Notify.success(SEND_OTP_SUCCESSFUL_TOAST));
          resolve();
        } else {
          dispatch(Notify.error(SEND_OTP_FAILURE_TOAST))
        }
      }).catch(error => {
        dispatch(Notify.error(SEND_OTP_FAILURE_TOAST))
        reject(error);
      });
    });
  };
};


export const verifyOtp = (data) => {
  return (dispatch, getState) => {

    const state = getState();
    const {mfaEmailAddress} = state.mfaReducer;

    return new Promise((resolve, reject) => {
      dispatch({
        type: VERIFY_OTP,
        payload: {
          request: {
            mode: 'no-cors',
            url: 'otp/verify',
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            data: {
              ...data,
              emailAddress: mfaEmailAddress,
            }
          }
        }
      }).then(response => {

        if (response.type === VERIFY_OTP_SUCCESS) {
          // dispatch(Notify.success(VERIFY_OTP_SUCCESSFUL_TOAST));
          resolve();
        }

      }).catch(error => {
        dispatch(Notify.error(VERIFY_OTP_FAILURE_TOAST));
        // reject(error);
      });
    });
  };
};

// export const sendOtp = (data) => {
//     return (dispatch, getState) => {
//
//         const state = getState();
//         const {mfaUsername} = state.mfaReducer;
//         const {selectedLanguage} = state.languageReducer;
//
//         dispatch({
//             type: SEND_OTP,
//             payload: {
//                 request: {
//                     mode: 'no-cors',
//                     url: 'otp/send',
//                     method: 'POST',
//                     headers: {
//                         'Content-Type': 'application/json'
//                     },
//                     data: {
//                         ...data,
//                         username: mfaUsername,
//                         language: selectedLanguage
//                     }
//                 }
//
//             }
//         })
//     };
// }

// export const verifyOtp = (data) => {
//     return (dispatch, getState) => {
//
//         const state = getState();
//         const {mfaUsername} = state.mfaReducer;
//
//         dispatch({
//             type: VERIFY_OTP,
//             payload: {
//                 request: {
//                     mode: 'no-cors',
//                     url: 'otp/verify',
//                     method: 'POST',
//                     headers: {
//                         'Content-Type': 'application/json'
//                     },
//                     data: {
//                         ...data,
//                         username: mfaUsername
//                     }
//                 }
//
//             }
//         })
//     };
// }


export const resetMfaState = () => ({
  type: RESET_MFA_STATE,
});


export const requestOtpVerification = (data) => ({
  type: REQUEST_OTP_VERIFICATION,
  payload: {
    data
  }
});



// WEBPACK FOOTER //
// ./src/redux/actions/mfaActions.js